/*
 * Vinci Region - Conteúdo por cidade (banners e vitrines da home)
 * Mostra/esconde seções e blocos conforme a cidade ativa (mesmo dado dos preços:
 * localStorage/cookie "vinci_region" -> { code }). Visual-only, client-side.
 *
 * Marcações no HTML:
 *  - Seção inteira:  [data-vr-section-target="all|preco_fXX"]  (esconde o .shopify-section)
 *  - Blocos:         container [data-vr-blocks-scope] com filhos [data-vr-target="..."]
 *  - Preview editor: [data-vr-preview="edit_all|all|preco_fXX"] no elemento de escopo
 *
 * O carrossel (bigazine-banner-carousel) faz o próprio filtro no script dele,
 * porque precisa reindexar slides/dots.
 */
(function () {
  "use strict";

  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  function readStorageCode() {
    try {
      var raw = window.localStorage.getItem("vinci_region");
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.code) return String(o.code).trim();
      }
    } catch (e) {}
    var m = document.cookie.match(/(?:^|;\s*)vinci_region=([^;]+)/);
    if (m) {
      try {
        var c = JSON.parse(decodeURIComponent(m[1]));
        if (c && c.code) return String(c.code).trim();
      } catch (e) {}
    }
    return "";
  }

  // Contexto a partir de um elemento de escopo (pode ter preview no editor)
  function contextFor(scopeEl) {
    if (DESIGN && scopeEl) {
      var pv = scopeEl.getAttribute("data-vr-preview") || "edit_all";
      if (pv === "edit_all") return { showAll: true, code: null };
      return { showAll: false, code: pv };
    }
    return { showAll: false, code: readStorageCode() };
  }

  function matches(target, ctx) {
    if (ctx.showAll) return true;
    if (!target || target === "all") return true;
    return target === ctx.code;
  }

  function applyWholeSections() {
    var nodes = document.querySelectorAll("[data-vr-section-target]");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var ctx = contextFor(el);
      var visible = matches(el.getAttribute("data-vr-section-target"), ctx);
      var wrapper = el.closest(".shopify-section") || el;
      wrapper.style.display = visible ? "" : "none";
    }
  }

  function applyBlockScopes() {
    var scopes = document.querySelectorAll("[data-vr-blocks-scope]");
    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      var ctx = contextFor(scope);
      var blocks = scope.querySelectorAll("[data-vr-target]");
      for (var j = 0; j < blocks.length; j++) {
        var b = blocks[j];
        b.style.display = matches(b.getAttribute("data-vr-target"), ctx) ? "" : "none";
      }
    }
  }

  function applyAll() {
    applyWholeSections();
    applyBlockScopes();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll);
  } else {
    applyAll();
  }
  window.addEventListener("vinci:region_changed", applyAll);
  document.addEventListener("shopify:section:load", applyAll);
  document.addEventListener("shopify:section:select", applyAll);
  document.addEventListener("shopify:section:deselect", applyAll);

  // Exposto para o carrossel reutilizar (com fallback próprio lá)
  window.VinciRegionContent = {
    readStorageCode: readStorageCode,
    contextFor: contextFor,
    matches: matches,
    apply: applyAll
  };
})();
